/* eslint-disable */
import 'firebase/auth';

import './src/styles/global.css';
import './src/styles/reset.css';
import './src/styles/variables.css';

import { AnimatePresence } from 'framer-motion';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import * as React from 'react';

import { StoreProvider } from './src/context/store-context';
import theme from './src/theme';

export const wrapRootElement = ({ element }) => {
  return (
    <StoreProvider>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          TransitionComponent={Fade}
          maxSnack={3}
        >
          <AnimatePresence exitBeforeEnter>{element}</AnimatePresence>
        </SnackbarProvider>
      </ThemeProvider>
    </StoreProvider>
  );
};
